<template>
    <div class="border-t border-grey-500" :class='[open && false ? "py-6" : "py-4"]'>
        <div class='flex items-center justify-between'>
            <!-- text-17 -->
            <p class="text-15 font-semibold" v-text='title' />
            <button type='button' class='stroke-black hover:stroke-grey-900' @click='filtersUpdated'>
                <IconArrowDown class='w-5 h-5' :class='{"rotate-180": open}' />
            </button>
        </div>

        <!-- w-full max-w-full whitespace-normal -->
        <p class='text-13 text-grey-900 max-w-full truncate pr-6 pt-[3px]' 
            v-if="!open" v-text='desc'
            v-tippy="{
                content: desc,
                placement: 'bottom-start',
                maxWidth: '295px',
            }"
        />

        <slot name='buttons' v-if='open'></slot>

        <TransitionHeight :visable="open">
            <!-- <div class='pt-3'> -->
                <slot />
            <!-- </div> -->
        </TransitionHeight>
    </div>
</template>

<script>
import page from '~/mixins/page';

export default {
    props: {
        page: Object,
        title: String,
        values: Array,
        filter: Object,
        order: Object,
        orderKey: String,
    },

    data() {
        return {
            open: false
        }
    },

    created() {
        if (this.page.user.page.filtersHidden && this.page.user.page.filtersHidden[this.hideKey] != undefined) {
            this.open = this.page.user.page.filtersHidden[this.hideKey]
        } else {
            this.open = true
        }

        this.$event.$on('page-updated', () => {
            if (this.page.user.page.filtersHidden) {
                this.open = this.page.user.page.filtersHidden[this.hideKey]
            } else {
                this.open = true;
            }
        })
    },

    watch: {
        'page': {
            handler() {
                if (this.page.user.page.filtersHidden) {
                    this.open = this.page.user.page.filtersHidden[this.hideKey]
                }
            },
            deep: true
        }
    },

    methods: {
        filtersUpdated() {
            this.open = !this.open

            if (! this.page.user.page.filtersHidden) {
                this.page.user.page.filtersHidden = {};
            }

            this.page.user.page.filtersHidden[this.hideKey] = this.open
            this.page.call().save()
        },
    },

    computed: {
        hideKey() {
            return this.filter ? this.filter.name : this.orderKey
        },

        desc() {
            let t = [];
            if (this.filter) {
                let check = this.filter.type == 'checkbox' ? this.values : [this.values];

                if (this.filter.type == "prospect_location_area") {
                    t.push(
                        this.filter.values.find(v => v.id == this.values)
                            .name
                    );
                } else {
                    for (let i in check) {
                        if (this.filter.values[check[i]] != null) {
                            t.push(this.filter.values[check[i]])
                        }
                    }
                }

                if (t.length == 0) {
                    t.push('No selections')
                }
            }

            if (this.order) {
                return this.orderKey + ' '
                    + this.order.find(o => o.name == this.orderKey)
                        .values[this.values].toLowerCase()
            }

            return t.join(', ')
        }
    }
}
</script>